import { Controller } from "@hotwired/stimulus"
import { csrfFetch } from "../lib/csrf_fetch"

export default class extends Controller {
  static values = {
    id: Number,
    organizationId: Number,
    redirectUrl: String
  }

  initialize() {
    this.dragOver = this.dragOver.bind(this)
    this.dragLeave = this.dragLeave.bind(this)
    this.drop = this.drop.bind(this)
    this.updateDocumentOwnership = this.updateDocumentOwnership.bind(this)
  }

  connect() {
    this.element.addEventListener("dragover", this.dragOver)
    this.element.addEventListener("drop", this.drop)
    this.element.addEventListener("dragleave", this.dragLeave)
  }

  dragOver(event) {
    event.preventDefault()
    this.element.classList.add("bg-info")
  }

  dragLeave(_event) {
    this.element.classList.remove("bg-info")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("bg-info")

    const dataTransferString = event.dataTransfer.getData("application/json")

    if (dataTransferString) {
      try {
        const dataTransferObject = JSON.parse(dataTransferString)

        const documentId = dataTransferObject.documentId

        this.updateDocumentOwnership(documentId)
      } catch (error) {
        console.error("Failed to parse dataTransfer data:", error)
      }
    } else {
      console.error("No data found in dataTransfer.")
    }
  }

  updateDocumentOwnership(documentId) {
    const data = {
      folder_id: this.idValue,
      document_id: documentId
    }

    const url = `/organizations/${this.organizationIdValue}/documentables/update_ownership`

    csrfFetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify(data)
    })
      .then(r => r.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }
}
